export default function initializeLocalAvailability() {
    const availability_select = document.querySelector('.local-availability-popup__select-size');
    const sizes = document.querySelectorAll('.warehouse-sizes-item__list-item');
    const warehouses = document.querySelectorAll('.warehouse-sizes-item');
    if (!availability_select) return;

    // pokazujemy salony w których jest produkt w wybranym rozmiarze
    availability_select.addEventListener('change', function (e) {
        var warehousesCount = 0;
        warehouses.forEach((item) => {
            item.classList.remove('active');
            const warehousesSizesString = item.dataset.available_sizes;
            const warehousesSizes = warehousesSizesString.split(',');
            const warehouseSizeItems = item.querySelectorAll('.warehouse-sizes-item__list-item');
            if ((e.target.value === '' && warehousesSizesString.length > 0) || (warehousesSizes.includes(e.target.value) && e.target.value !== '')) {
                item.classList.add('active');
                warehousesCount++;
                warehouseSizeItems.forEach((item) => {
                    item.classList.remove('active');
                    if (item.dataset.size === e.target.value || e.target.value === '') {
                        item.classList.add('active');
                    }
                });
            }
        });

        // get last active warehouse
        const lastActiveWarehouse = document.querySelector('.warehouse-sizes-item.active');
        if (lastActiveWarehouse) {
            lastActiveWarehouse.classList.add('warehouse-sizes-item--last-active');
        }

        // pokazujemy tylko wybrany rozmiar na liście salonów
        sizes.forEach((item) => {
            item.classList.remove('warehouse-sizes-item__list-item--active');
            if (item.dataset.size === e.target.value || e.target.value === '') {
                item.classList.add('warehouse-sizes-item__list-item--active');
            }
        });

        if (warehousesCount === 0) {
            document.querySelector('.local-availability-popup__no-warehouses').classList.add('active');
        } else {
            document.querySelector('.local-availability-popup__no-warehouses').classList.remove('active');
        }

    });

    availability_select.dispatchEvent(new Event('change'));
}